import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import Modal from 'react-responsive-modal';
import { useDispatch, useSelector } from 'react-redux';
import MarkPanel from './MarkPanel/MarkPanel';

export const TableCell = ({
  mark,
  student,
  panelOpen,
  setPanelOpen,
  formData,
  commentOpen,
  setCommentOpen,
  setClassbook,
  getActiveSell,
  classbook,
  selected,
  setSelected,
  handleActive,
  updateSheidAverage,
  gradecomment,
  onColumnSelected,
}) => {

  const dispatch = useDispatch();
  const { gradeValue } = useSelector(state => state.classbook);
  const [editMode, setEditMode] = useState(false);
  const [value, setValue] = useState(mark);

  // Обработчик клика - выделить ячейку и включить режим редактирования
  const handleCellClick = () => {
    // Закрыть панель если открыта
    if (panelOpen.mid && panelOpen.lessonid) {
      setPanelOpen({ mid: null, lessonid: null })
      return
    }
    // Выделить ячейку (сохраняем предыдущее поведение)
    handleActive({ mid: student.mid, lessonid: student.lessonid })
    // Включить режим редактирования
    setEditMode(true)
    setValue(student.grade || '')
  }

  // Обработчик изменения input
  const handleInputChange = (e) => {
    const val = e.target.value
    // Разрешить только цифры 1-5, максимум 5 символов
    if (val === '' || /^[1-5]{0,5}$/.test(val)) {
      setValue(val)
    }
  }

  // Обработчик потери фокуса - сохранение
  const handleBlur = async () => {
    const originalGrade = (student.grade || '').toString()
    if (value !== originalGrade) {
      cellChanging('grade', value || null)
      // Обновить средний балл по sheid
      if (updateSheidAverage) {
        updateSheidAverage(student.sheid, value, student.mid, student.lessonid)
      }
    }
    setEditMode(false)
  }

  // Обработчик клавиш
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur()
    }
    if (e.key === 'Escape') {
      setValue(student.grade || '')
      setEditMode(false)
    }
  }

  const cellChanging = (name, num) => {
    setValue(num)
    const isInSelection = selected.find(
      s => s.mid === student.mid && s.lessonid === student.lessonid
    )
    if (selected.length > 1 && isInSelection) {
      selected.forEach(sel => {
        const target = classbook.find(c => c.mid === sel.mid && c.lessonid === sel.lessonid)
        if (target) {
          dispatch(setClassbook({
            ...target,
            teachermid: target.teachermid || target.teachermids,
            gradeweight: target.gradeweight || 1,
            [name]: num,
          }, formData))
        }
      })
    } else {
      const teachermid = student.teachermid || student.teachermids
      const gradeweight = student.gradeweight || 1
      dispatch(setClassbook({ ...student, teachermid, gradeweight, [name]: num }, formData))
    }
  }

  // const handleActive = ({mid, lessonid}) => {
  //   if (panelOpen.mid && panelOpen.lessonid) {
  //     setPanelOpen({mid: null, lessonid: null})
  //   } else if (selected.find(el => (el.mid == mid) && (el.lessonid == lessonid))) {
  //     const arr = selected.filter(el => el.mid != mid && el.lessonid != lessonid);
  //     setSelected(arr)
  //   } else {
  //     setSelected([...selected, {mid: mid, lessonid: lessonid}])
  //   }
  // }

  const CheckboxType = (student) => {
    if (student.gradecomment) return "lightgrey"
    else return "white"
  }

  const handleRightClick = (e, { mid, lessonid }) => {
    e.preventDefault();
    if (e.button === 2) {
      // Выйти из режима редактирования при правом клике
      if (editMode) {
        setEditMode(false)
      }
      // Выделить ячейку если не выделена
      if (!selected.find(el => (el.mid == mid) && (el.lessonid == lessonid))) {
        setSelected([...selected, { mid, lessonid }])
      }
      // Открыть MarkPanel
      setPanelOpen({ mid: mid, lessonid: lessonid })
    }
  }

  const handleOpenComment = ({ mid, lessonid, student: studentData }) => {
    setCommentOpen({ mid, lessonid, student: studentData || student });
  }

  return (
    <>
      <td style={{ padding: '0px', textAlign: 'center', userSelect: 'none', width: '38px', minWidth: '38px', maxWidth: '38px' }}>
        {student.lessondate !== "Ср. балл" && student.student !== "Ср. балл" && student.lessondate !== "Учебный период" ?

          <div
            onClick={handleCellClick}
            onContextMenu={(e) => e.preventDefault()}
            onMouseDown={(e) => handleRightClick(e, { mid: student.mid, lessonid: student.lessonid })}
            className={styles.cell}
            style={{ backgroundColor: selected.find(el => (el.mid == student.mid) && (el.lessonid == student.lessonid)) ? '#3689FF' : CheckboxType(student) }}
            title={gradecomment}
          >
            {editMode ? (
              <input
                type="text"
                value={value}
                onChange={handleInputChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                onClick={(e) => e.stopPropagation()}
                autoFocus
                maxLength={5}
                className={styles.cellInput}
              />
            ) : (
              student.grade
            )}
            {(panelOpen.mid == student.mid) && (panelOpen.lessonid == student.lessonid) ?
              <MarkPanel
                classbook={classbook}
                setSelected={setSelected}
                selected={selected}
                student={student}
                setPanelOpen={setPanelOpen}
                gradeValue={gradeValue}
                cellChanging={cellChanging}
                handleOpenComment={handleOpenComment}
                onColumnSelected={onColumnSelected} /> : null
            }
          </div>
          :
          <span>{value}</span>
        }
      </td>
    </>
  )
}

